// hooks/use-submission-requests.ts
import { useState } from "react";
import { toast } from "react-toastify";
import { SUBMISSION_REQUEST_STATUSES, submissionRequestDriver } from '../../../utils/types';
import { useGetAllSubmissionRequests } from '../../../apis/submission-requests/get-all-submission-requests';
import { useModifySubmissionRequest } from '../../../apis/submission-requests/modify-submission-requests';

const useSubmissionRequests = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingId, setLoadingId] = useState<string | null>(null);
    const [selectedRequest, setSelectedRequest] = useState<submissionRequestDriver | null>(null);
    const [isViewSelectedModalShowing, setIsViewSelectedModalShowing] = useState(false);

    const { data, isFetching, refetch } = useGetAllSubmissionRequests({ page: currentPage });
    const { mutateAsync: modifyRequest } = useModifySubmissionRequest();

    const submissions = data?.docs ?? [];
    const totalPages = data?.totalPages ?? 0;

    const handleModifyRequest = async (id: string, status: SUBMISSION_REQUEST_STATUSES) => {
        setLoadingId(id);
        try {
            await modifyRequest({ id, status });
            refetch();
        } catch (error: any) {
            toast.error(error?.response?.data?.error || "Something went wrong please try again later");
        }
        setLoadingId(null);
    };

    const handleViewRequest = (request: submissionRequestDriver) => {
        setSelectedRequest(request);
        setIsViewSelectedModalShowing(true);
    };

    const handleCloseViewRequest = () => {
        setSelectedRequest(null);
        setIsViewSelectedModalShowing(false);
    };

    return {
        submissions,
        totalPages,
        isFetching,
        currentPage,
        setCurrentPage,
        loadingId,
        selectedRequest,
        isViewSelectedModalShowing,
        handleModifyRequest,
        handleViewRequest,
        handleCloseViewRequest,
    };
};

export default useSubmissionRequests;